<template>
  <div v-if="isLogin" class="relative">
    <div v-if="usercenter" class="usercenter-account">
      <span class="usercenter-account__name">{{ userInfo.username }}</span>
      <button type="button" class="usercenter-account__logout" @click="handleSignOut">
        {{ $t("header.signout") }}
      </button>
    </div>
    <div v-else class="relative">
      <a @click="handleClickUserName" class="relative z-10 overflow-hidden border-none border-gray-600 font-bold focus:outline-none focus:border-white text-red-500 cursor-pointer" :class="{'!text-gray-500': usercenter}">
        {{ usercenter ? userInfo.username : $t("header.dashboard") }}
        <svg width="19" height="14" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block animate-go">
          <path d="M0.0902161 9.58947L16.7281 9.58947" stroke="currentColor" stroke-width="2"/>
          <path d="M8.5 1L16.9998 9.49981L8.5 17.9996" stroke="currentColor" stroke-width="2"/>
        </svg>
      </a>
    </div>
  </div>


  <div v-else class="relative">
    <a v-if="showLogin" href="/login" :class="[ showSignup ? 'mt-1 px-2 py-1 hover:text-red-500 font-semibold hover:border-b-1 sm:mt-0 sm:ml-2' : 'mt-1 px-[16px] py-[10px] leading-[25px] text-[#1c3b3b] hover:opacity-80 hover:border-b-1 sm:mt-0 sm:ml-2 text-[#2f3333] bg-white box-border rounded-full font-bold', {'text-slate-900 bg-transparent border border-slate-300': hasBackground && !showSignup}]">{{ $t("header.login") }}</a>
    <a v-if="showSignup" href="/signup" class="mt-1 px-[16px] py-[10px] leading-[25px] opacity-80 hover:opacity-100 sm:mt-0 sm:ml-2 text-[#1c3b3b] bg-white box-border rounded-full font-bold" :class="{'text-slate-900 bg-transparent border border-slate-300': hasBackground}">{{ $t("header.signup") }}</a>
  </div>
</template>

<script>
import { debounce } from '@/util/debounce'
import { logout } from '@/http/api/member'
import { cookieAuthEnabled } from '@/http/authMode'

export default {
  props: {
    usercenter: {
      type: Boolean,
      default: () => false
    },
    showLogin: {
      type: Boolean,
      default: true
    },
    showSignup: {
      type: Boolean,
      default: true
    },
    hasBackground: {
      type: Boolean,
      default: false
    },
  },
  
  computed: {
    isLogin() {
      return this.$store.state.isLogin
    },
    userInfo(){
      return this.$store.state.userInfo
    }
  },
  methods: {
    handleClickUserName() {
      this.$router.replace({path:'/ucenter/info'});
    },

    async handleSignOut(){
      if (cookieAuthEnabled) {
        try {
          await logout()
        } catch (error) {
          if (error?.response?.status !== 401) {
            this.$message.error('Sign out failed. Please retry.')
            return
          }
        }
      }
      this.$store.commit('vuexSignOut');
      this.$nextTick(() => {
        const navigateToLogin = debounce(() => {
          // console.log(`Check Route to Login. Current: ${this.$route.path}`)
          if (this.$route.path !== '/login') {
            this.$router.replace({ path: '/login' }).catch((e) => {
              console.log(e);
            });
          }
        }, 100); // Adjust the debounce delay as needed
        navigateToLogin();
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.usercenter-account {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #5d6675;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
}

.usercenter-account__name {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.usercenter-account__logout {
  appearance: none;
  min-height: 32px;
  padding: 0 14px;
  border: 1px solid rgba(93, 102, 117, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.74);
  color: #5d6675;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.usercenter-account__logout:hover {
  border-color: rgba(255, 143, 11, 0.55);
  background: rgba(255, 248, 238, 0.96);
  color: #d76e00;
  box-shadow: 0 8px 20px rgba(255, 143, 11, 0.14);
}
</style>
